module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority-new/customer/customer-06-0d96e89e648c62aba46af766892b14f2.jpg";